import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { errorsInput } from 'src/consts';
import { addPlusOnPhone, isPhoneValid } from 'src/helpers';
import { Role, UserSimpleInfo } from 'src/types';
import * as Yup from 'yup';
import { UpdateUserInputs } from '../users.types';
import { useUserAdapterModelToFormData } from './useUserAdapterModelToFormData';

type Props = {
  initialValues: UserSimpleInfo;
};

export const useUpdateUserForm = ({ initialValues }: Props) => {
  const { t } = useTranslation();

  const { userFormData } = useUserAdapterModelToFormData(initialValues);
  const schema = Yup.object().shape({
    firstName: Yup.string().required(t('forms.required-field')),
    lastName: Yup.string().required(t('forms.required-field')),
    tel: Yup.string()
      .nullable()
      .required(t('forms.required-field'))
      .test('phone', t('forms.invalid-phone-format'), (value: string | null | undefined) => {
        if (!value) {
          return false;
        }

        const result = isPhoneValid(addPlusOnPhone(value));
        return result;
      }),
    email: Yup.string().nullable().required(errorsInput.required).email(t(errorsInput.emailInvalidFormat)),
    address: Yup.string().nullable(),
    role: Yup.string().required(t('forms.required-field')),
    agencies: Yup.array().when('role', {
      is: (role: string) => (['AGENT', 'PARTNER'] as Role[]).includes(role as Role),
      then: Yup.array().min(1, t('dashboard-user-update.should-select-min-one-agency')),
      otherwise: Yup.array().nullable(),
    }),
  });

  const {
    handleSubmit,
    control,
    formState: { isDirty, errors, isSubmitted },
  } = useForm<UpdateUserInputs>({
    resolver: yupResolver(schema),
    defaultValues: userFormData,
  });

  return {
    handleSubmit,
    control,
    isDirty: isDirty && !isSubmitted,
    errors,
  };
};
